var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1006",
    d: "M15.375 6.375V6.375C16.3415 6.375 17.125 7.1585 17.125 8.125V26.375C17.125 27.4796 16.2296 28.375 15.125 28.375H5.125C4.02043 28.375 3.125 27.4796 3.125 26.375V8.125C3.125 7.1585 3.9085 6.375 4.875 6.375V6.375",
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1017",
    d: "M19.125 10.375H25.125C26.2296 10.375 27.125 11.2704 27.125 12.375V22.375C27.125 23.4796 26.2296 24.375 25.125 24.375H19.125",
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1016",
    x: 6.125,
    y: 12.375,
    width: 8,
    height: 2,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 434"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1007",
    x: 5.125,
    y: 16.375,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1010",
    x: 5.125,
    y: 20.1992,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1013",
    x: 5.125,
    y: 24.0234,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1008",
    x: 9.08594,
    y: 16.375,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1011",
    x: 9.08594,
    y: 20.1992,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1014",
    x: 9.08594,
    y: 24.0234,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1009",
    x: 13.0469,
    y: 16.375,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1012",
    x: 13.0469,
    y: 20.1992,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1015",
    x: 13.0469,
    y: 24.0234,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M5.75391 3.375L6.08285 2.99845C5.93516 2.86942 5.72567 2.83866 5.54711 2.91977C5.36856 3.00088 5.25391 3.17888 5.25391 3.375H5.75391ZM7.19281 4.63199L6.86386 5.00854C7.05227 5.17314 7.33334 5.17314 7.52175 5.00854L7.19281 4.63199ZM8.63171 3.375L8.96065 2.99845C8.77224 2.83385 8.49117 2.83385 8.30276 2.99845L8.63171 3.375ZM10.0706 4.63199L9.74166 5.00854C9.93007 5.17314 10.2111 5.17314 10.3996 5.00854L10.0706 4.63199ZM11.5095 3.375L11.8385 2.99845C11.65 2.83385 11.369 2.83385 11.1806 2.99845L11.5095 3.375ZM12.9484 4.63199L12.6195 5.00854C12.8079 5.17314 13.0889 5.17314 13.2774 5.00854L12.9484 4.63199ZM14.3873 3.375H14.8873C14.8873 3.17888 14.7727 3.00088 14.5941 2.91977C14.4155 2.83866 14.2061 2.86942 14.0584 2.99845L14.3873 3.375ZM13.8873 9.68741C13.8873 9.96355 14.1112 10.1874 14.3873 10.1874C14.6634 10.1874 14.8873 9.96355 14.8873 9.68741H13.8873ZM6.25391 9.68741V3.375H5.25391V9.68741H6.25391ZM5.42496 3.75155L6.86386 5.00854L7.52175 4.25544L6.08285 2.99845L5.42496 3.75155ZM7.52175 5.00854L8.96065 3.75155L8.30276 2.99845L6.86386 4.25544L7.52175 5.00854ZM8.30276 3.75155L9.74166 5.00854L10.3996 4.25544L8.96065 2.99845L8.30276 3.75155ZM10.3996 5.00854L11.8385 3.75155L11.1806 2.99845L9.74166 4.25544L10.3996 5.00854ZM11.1806 3.75155L12.6195 5.00854L13.2774 4.25544L11.8385 2.99845L11.1806 3.75155ZM13.2774 5.00854L14.7163 3.75155L14.0584 2.99845L12.6195 4.25544L13.2774 5.00854ZM13.8873 3.375V9.68741H14.8873V3.375H13.8873Z",
    fill: "#566376"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    x1: 4.625,
    y1: 10.1133,
    x2: 15.6792,
    y2: 10.1133,
    stroke: "#566376",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M24.125 11.375L24.125 24.375",
    stroke: "#566376",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 20.625,
    y1: 17.875,
    x2: 20.625,
    y2: 21.875,
    stroke: "#566376",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 20.625,
    y1: 12.375,
    x2: 20.625,
    y2: 16.375,
    stroke: "#566376",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCsvIcon);
export default __webpack_public_path__ + "static/media/upload-csv-icon.e61ec1c86ec507e908dbb9fd9dfb21ff.svg";
export { ForwardRef as ReactComponent };